module.exports = __webpack_public_path__ + "static/assets/10af80546707afae5507edb828dd35a0.mp3";